const colours = {
  grey: 'rgb(61, 62, 65)',
  blue: 'rgb(63, 191, 198)',
  green: 'rgb(140, 208, 36)',
}

export default colours;